<template><svg width="5" height="8" viewBox="0 0 5 8" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M0.94 -8.21774e-08L8.21774e-08 0.94L3.05333 4L6.17205e-07 7.06L0.940001 8L4.94 4L0.94 -8.21774e-08Z" />
</svg>
</template>